// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3615": "995efd144f0e","6046": "9e6d8f2d757b","8795": "631c6af3ebb8",}[chunkId] + ".css"
}